import { withEnumBadge } from "@/components/EnumBadge.tsx";
import { coverageDescriptions } from "@/modules/metal/statusLabels.tsx";

export const CoverageStatusBadge = withEnumBadge(coverageDescriptions);
